import React from 'react';
import { Div, P, Span } from '../element';
import { Link } from 'react-router-dom';
import { Checkmark } from 'grommet-icons';
export const WizardStepCheckItem = ({
  path,
  text,
  status,
  queryString,
  steptitle,
}) => (
  <Div className="stepCheckItem">
    <Link
      to={path + queryString}
      data-test-id="wc-link-wizard-step"
      data-title={text}
    >
      <Span className={`btn ${status}`}>
        {status === 'completed' && (
          <Checkmark style={{ width: '12px', height: '22px' }} color="white" />
        )}
        {status === 'active' && <Span className="inner" />}
      </Span>
    </Link>
    <P className={`${status} ${text !== '' ? text.split(' ').join('') : ''}`}>
      {steptitle !== '' ? steptitle : text}
    </P>
  </Div>
);
